import { render } from "./ProjectSourceBanner.vue?vue&type=template&id=37717776&lang=true"
import script from "./ProjectSourceBanner.vue?vue&type=script&lang=js"
export * from "./ProjectSourceBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__